var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"container self-container"},[_c('CommentSlice',{attrs:{"setCommentNum":_vm.setCommentNum,"publishUserId":_vm.publishUserId,"articleId":_vm.articleId,"btnText":"发表","hits":"请聊聊最近找工作的感受吧"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }